export default {"src":"/_next/static/media/switch_logo.a30931eb.svg","height":788,"width":963};